/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BudgetHistoryDataModel {
    getFixupPrototypeFunction() { return BudgetHistoryDataModel.fixupPrototype; }

    static newInstance(model: Partial<BudgetHistoryDataModel>): BudgetHistoryDataModel {
        let obj = Object.assign(new BudgetHistoryDataModel(), model);
        BudgetHistoryDataModel.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BudgetHistoryDataModel>): BudgetHistoryDataModel {
        if (!model) return null;
        return BudgetHistoryDataModel.newInstance(<BudgetHistoryDataModel> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BudgetHistoryDataModel) {
        if (!obj) return;

        models.BudgetHistoryDataModel.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BudgetHistoryDataModel): boolean {
        Object.setPrototypeOf(obj, BudgetHistoryDataModel.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.budget_variance_percentage === undefined) {
            this.budget_variance_percentage = 0;
        }
        if (this.budget_variance === undefined) {
            this.budget_variance = 0;
        }
        if (this.actual_amount === undefined) {
            this.actual_amount = 0;
        }
        if (this.forecasted_amount === undefined) {
            this.forecasted_amount = 0;
        }
        if (this.budget_amount === undefined) {
            this.budget_amount = 0;
        }
    }

    /**
     * budget variance percentage
     */
    budget_variance_percentage: number;

    /**
     * budget variance
     */
    budget_variance: number;

    /**
     * actual amount
     */
    actual_amount: number;

    /**
     * forecasted amount, null for closed periods
     */
    forecasted_amount: number;

    /**
     * budget amount
     */
    budget_amount: number;

    /**
     * budget amount until this date
     */
    date: string;

    /**
     * budget currency
     */
    currency: string;

    /**
     * budget history of budget id
     */
    budget_id: string;

}
